import CirclePlus from '../../src/legacy/CirclePlus';
export default CirclePlus;
